import { createReducer, on } from '@ngrx/store';
import * as MapSettingsActions from '../actions/map-settings.actions';

export const mapSettingsFeatureKey = 'mapSettings';

export interface State {
  baseMap: 'roadmap' | 'hybrid';
  trafficLayer: boolean;
  locationLayer: boolean;
  selectedLayer: string | null;
  mapLoaded: boolean;
}

export const initialState: State = {
  selectedLayer: null,
  baseMap: 'roadmap',
  trafficLayer: false,
  locationLayer: false,
  mapLoaded: false,
};

export const reducer = createReducer(
  initialState,
  on(MapSettingsActions.loadMapSettingsSuccess, (state, { mapSettings }) =>
    !!mapSettings ? mapSettings : initialState,
  ),
  on(MapSettingsActions.setBaseMap, (state, { baseMap }) => ({
    ...state,
    baseMap,
  })),
  on(MapSettingsActions.toggleTrafficLayer, (state) => ({
    ...state,
    trafficLayer: !state.trafficLayer,
  })),
  on(MapSettingsActions.toggleLocationLayer, (state) => ({
    ...state,
    locationLayer: !state.locationLayer,
  })),
  on(MapSettingsActions.setSelectedLayer, (state, { selectedLayer }) => ({
    ...state,
    selectedLayer,
  })),
  on(MapSettingsActions.setMapLoaded, (state) => ({
    ...state,
    mapLoaded: true,
  })),
);

export const getSelectedLayer = (state: State) => state.selectedLayer;
export const getBaseMap = (state: State) => state.baseMap;
export const getTrafficLayer = (state: State) => state.trafficLayer;
export const getLocationLayer = (state: State) => state.locationLayer;
export const getMapLoaded = (state: State) => state.mapLoaded;
